class Escaleras {
    constructor(target) {
        this.target = target;
        this.escaleraSube = target.querySelector('escalera-sube')
        this.escaleraBaja = target.querySelector('escalera-baja')
        const bajar = this.escaleraBaja.clientHeight - window.innerHeight
        const subir = this.escaleraSube.clientHeight - window.innerHeight
        const tl = gsap.timeline({ delay: 2, defaults: { duration: 3 } })
        tl.to(this.escaleraBaja, { y: bajar }, 0)
        tl.to(this.escaleraSube, { y: -subir }, 0)

        ScrollTrigger.create({
            trigger: this.target,
            animation: tl,
            start: "top top",
            end: "+=4000 ",
            scrub: true,
            pin: "#pin",
            anticipatePin: 1,
            onEnter: this.onEnter,
            onEnterBack: this.onEnter,
            onLeaveBack: this.onLeave,
            onLeave: this.onLeave,
        })
    }

    onEnter(){
        console.log('entro');
        document.getElementById('page-header').classList.add('custom')
    }
    onLeave(){
        console.log('salio');
        document.getElementById('page-header').classList.remove('custom')
    }
}

class Tabs{
    constructor(target){
        this.target = target
        this.summarys = target.querySelectorAll("summary")
        this.details = target.querySelectorAll("details")
        this.currentOpen = undefined
        this.summarys.forEach(sumary => {
            sumary.onclick = this.close.bind(this);
        });
        this.details.forEach(details => {
            details.ontoggle = this.resize;
            const btnClose = details.querySelector('.btnClose');
            if (btnClose) {
                btnClose.onclick = () => details.removeAttribute('open')
            }
        });
    }

    close(e){
        if (this.currentOpen && this.currentOpen != e.target.parentElement) {
            this.currentOpen.removeAttribute('open')
        }
        this.currentOpen = !e.target.parentElement.open ? e.target.parentElement: undefined;
    }
    resize(e) {
        const content = this.querySelector('.content')
        if (this.open) {
            this.style.height = `${content.clientHeight + this.clientHeight}px`
            content.animate({opacity: [0,1]}, {duration: 0, fill:"forwards"})
        }else{
            this.style.height = "auto"
        }
    }
}

class Socio extends HTMLElement{
    constructor(){
        super()
        this.duracion = 240
        this.openKeyFrames = [
            {transform: "scale(0)", opacity:0},
            {transform: "scale(1)", opacity:1},
        ]
        this.closeKeyFrames = [
            {transform: "scale(0)", opacity:0}
        ]
    }

    connectedCallback(){
        const template = this.querySelector('template')
        this.modal = template ? template.content.querySelector('nexos-modal'): undefined
        const figure = this.querySelector('.figure-member')
        const btnClose = this.modal.querySelector('.btnClose')
        if (figure) {
            figure.addEventListener('click', this.openModal.bind(this))
        }
        if (btnClose) {
            btnClose.addEventListener('click', this.closeModal.bind(this))
        }
    }
    openModal(){
        document.body.appendChild(this.modal)
        this.modal.animate(this.openKeyFrames, this.duracion).onfinish = ()=>{
            document.body.classList.add('open-modal')
        }
    }
    closeModal(){
        document.body.classList.remove('open-modal')
        document.body.removeChild(this.modal)
        

    }
}

customElements.define('nexos-socio', Socio)